import { Step, StepLabel, Typography } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import { Images } from 'assets/images';
import { BackButton } from 'components';
import { StyledNoSelected, StyledStepImage, StyledStepper, StyledStepperHeader } from './styled';

export const StepperContent = ({
  questions,
  activeStep,
  isStepSkipped,
}) => {
  
  const navigate = useNavigate();

  const isStepOptional = (step) => step !== questions.length;

  const ColorLibStepIcon = (props) => {
    const { completed } = props;

    const icons = [
      <StyledStepImage key={Images.stepperDone} src={Images.stepperDone} alt="checked" />,
    ];

    questions.data.forEach(() => {
      if (completed) {
        icons.push(
          <StyledStepImage src={Images.stepperDone} alt="checked" />,
        );
      } else {
        icons.push(<StyledNoSelected />);
      }
    });

    return <div>{icons[String(props.icon)]}</div>;
  };

  return(
    <StyledStepperHeader>
      <BackButton handleClick={() => navigate(-1)} />

      {questions?.data?.length >= activeStep && (
        <StyledStepper activeStep={activeStep}>
          {questions?.data &&
          questions.data.map((question, index) => {

            const stepProps = {};
            const labelProps = {};

            if (isStepOptional(index)) {
              labelProps.optional = (
                <Typography variant="caption">Optional</Typography>
              );
            }

            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }

            return (
              <Step key={question.position} {...stepProps}>
                <StepLabel StepIconComponent={ColorLibStepIcon}>
                  {question.label}
                </StepLabel>
              </Step>
            );
          })}
        </StyledStepper>
      )}
    </StyledStepperHeader>
  );
};
